import styled from 'styled-components'
import { CommonLabel } from '../styles';

export const Title = styled(CommonLabel)`
  grid-area: title;
  cursor: pointer;
`;
